<template>
  <div class="mt-4">
    <label class="block text-sm font-bold text-gray-700 mb-2">
      Preferences
    </label>
    <label class="block text-xs text-gray-500 mb-2">Note</label>
    <textarea
      :value="value"
      @input="$emit('input', $event.target.value)"
      placeholder="List any special requests. Example: allergies, extra spicy, etc"
      class="w-full p-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-primary-600 focus:ring-0 transition-colors resize-none h-20 text-sm"
      rows="3"
      max-rows="6"
    />
  </div>
</template>

<script>
export default {
  name: "ProductNotes",
  props: {
    value: {
      type: String,
      default: ""
    }
  }
};
</script>
